@for (row of rows; track row; let rowIndex = $index) {
  <tr role="row">
    @for (item of row; track item; let colIndex = $index) {
      <td
        role="gridcell"
        class="event-calendar-body-cell"
        [ngClass]="item.cssClasses"
        [class.event-calendar-body-cell-focused]="
          isTodayCell(item.compareValue)
        "
        [class.event-calendar-body-cell-disabled]="!item.enabled"
        [class.event-calendar-body-cell-pointer]="canEdit"
        [attr.aria-label]="item.ariaLabel"
        [attr.aria-disabled]="!item.enabled || null"
        (click)="
          !(item.leftEventsNumber > 0) && onEventCreatedClick(item.rawValue)
        "
      >
        <div class="cell">
          <div class="cell-title">
            @if (isTodayCell(item.compareValue)) {
              <span>
                {{ '_library.calendar.today' | translate }}
              </span>
            }
            <span>{{ item.displayValue }}</span>
          </div>
          <div class="cell-list">
            @for (event of item.eventsToShow; track trackByFnc($index, event)) {
              <myre-event-calendar-event
                [event]="event"
                (onEventUpdated)="onEventUpdatedEmit($event)"
              />
            }
            @if (item.leftEventsNumber > 0) {
              <myre-event-calendar-popup
                [eventCalendarDay]="item"
                [canEdit]="canEdit"
                [isOpen]="isOpen"
                (onEventCreated)="onEventCreatedClick($event)"
                (onEventUpdated)="onEventUpdatedEmit($event)"
                (onClosePopups)="onClosePopupsEmit($event)"
              />
            }
          </div>
        </div>
      </td>
    }
  </tr>
}
